;(function ($, window, document, undefined) {
	'use strict';

	var pluginName = 'videoSlider',
		defaults = {
			//
		};

	function Plugin(element, options) {
		this.$element = $(element);
		this.options = $.extend({}, defaults, options);

		this.$videosSlider = this.$element.find('.js-videoSlider__videos');
		this.$captionsSlider = this.$element.find('.js-videoSlider__captions');

		this.init();
	}

	var methods = {
		init: function() {
			var self = this;

			this.$element.removeClass('hiddenOnLoad');
			this.initSlider();

			$(window).on('debouncedwidth', function() {
				self.destroySlider();
				self.initSlider();
			});

			// if (window.matchMedia) {
			// 	var mediaQueryList = window.matchMedia('print');

			// 	mediaQueryList.addListener(function(mql) {
			// 		if (mql.matches) {
			// 			self.destroySlider();
			// 		} else {
			// 			self.initSlider();
			// 		}
			// 	});
			// }

			// window.onbeforeprint = self.destroySlider();
			// window.onafterprint = self.initSlider();
		},

		initSlider: function() {
			this.initVideosSlider();
			this.initCaptionsSlider();
			this.handlePlayerEvents();
		},

		destroySlider: function() {
			this.$videosSlider.slick('unslick');
		},

		initVideosSlider: function() {
			var self = this;

			this.$videosSlider.slick({
				infinite: false,
				speed: 500,
				prevArrow: '<div class="slick-prev slick-arrow"><div class="icon-arrow-left icon"><svg xmlns="http://www.w3.org/2000/svg"><path d="M15 21.18L5.729 12 15 2.82 12.146 0 0 12l12.146 12L15 21.18" /></svg></div></div>',
				nextArrow: '<div class="slick-next slick-arrow"><div class="icon-arrow-right icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 24"><path d="M0 2.8L9.3 12 0 21.2 2.9 24 15 12 2.9 0 0 2.8"/></svg></div></div>'
			});

			this.$videosSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				self.$captionsSlider.slick('slickGoTo', nextSlide);
			});
		},

		initCaptionsSlider: function() {
			this.$captionsSlider.slick({
				arrows: false,
				draggable: false,
				fade: true,
				cssEase: 'linear',
				infinite: false,
				speed: 300,
				slidesToShow: 1
			});
		},

		handlePlayerEvents: function() {
			var players = $('.video-js');

			players.on('play', function() {
				var currentPlayerIndex = $(this).parents('.videoSlider__item').index();

				players.each(function(index, player) {
					if (index !== currentPlayerIndex) {
						player.pause();
					}
				});
			});
		}
	};

	$.extend(Plugin.prototype, methods);

	$.fn[pluginName] = function (options) {
		this.each(function() {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));

				$.triggerFailsafeEvent($(this), 'plugin_' + pluginName + '.ready');
			}
		});

		if (this.length > 0) {
			$.triggerFailsafeEvent($(window), 'plugin_' + pluginName + '.ready_all');
		}

		return this;
	};

})(jQuery, window, document);
